import React from 'react';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import { checkMot } from '../../../ressources/functionJS/checkMot';

const MdpMetre = ({ password, valeurForceMDP }) => {
  const createPasswordLabel = (result) => {
    switch (result.score) {
      case 0:
        return checkMot('faible');
      case 1:
        return checkMot('faible');
      case 2:
        return checkMot('raisonnable');
      case 3:
        return checkMot('bon');
      case 4:
        return checkMot('fort');
      default:
        return checkMot('faible');
    }
  };
  /*
  TODO implement new progress bar with new design and new library
  <ProgressBarLine
            value={valeurForceMDP.score}
            min={0}
            max={4}
            strokeWidth={5}
            trailWidth={5}
            text={password && <>{createPasswordLabel(valeurForceMDP)}</>}
            styles={{
              path: {
                stroke: '#f5cb5a',
              },
              trail: {
                stroke: '#f1f1f1',
              },
              text: {
                fill: '#a6163f',
                textAlign: 'center',
                fontSize: '14px',
              },
            }}
          />
*/
  return (
    <>
      <div className={s.row}>
        <div className={s.col_sm_7}></div>
      </div>
    </>
  );
};

export default MdpMetre;
